import { Box, Button } from "@mui/material"
import React from "react"
import { IconTrash } from "../../custom-icons/icon-trash"
import { customPalette } from "../../../../theme"

interface IProps {
  label: string | undefined
  fullWidth?: boolean
  isSubmitting?: boolean

  onClick(): void
}

export function DeleteButton({ onClick, label, fullWidth = false, isSubmitting }: Readonly<IProps>): React.JSX.Element {
  return (
    <Button
      variant="contained"
      size="medium"
      onClick={onClick}
      fullWidth={fullWidth}
      disabled={isSubmitting}
      color="secondary"
      sx={{
        borderRadius: 3,
        backgroundColor: customPalette.backgroundLightRed,
        color: customPalette.textRed,
        "&:hover": {
          backgroundColor: customPalette.backgroundHoveredRed,
        },
      }}>
      <Box display="flex" alignItems="center" gap={1}>
        <IconTrash
          sx={{
            color: customPalette.textRed,
            width: 17,
            height: 17,
          }}
        />
        {label}
      </Box>
    </Button>
  )
}
